<template>
    <div class="field is-horizontal">
        <div class="field-label is-normal">
            <label class="label">Goal for {{ manager.name }}</label>
        </div>
        <div class="field-body">
            <div class="field">
                <p class="control">
                    <input class="input is-warning" :class="{'is-loading' : isLoading }" @change="updateUserSettings" type="number" v-model="manager_goal" :placeholder="'Assign goal for ' + manager.name">
                </p>
            </div>
        </div>
    </div>
</template>

<script>
    import apiUsers from './../../../api/apiUsers'
    export default {
        data() {
            return {
                isLoading: false,
            }
        },
        computed: {
            manager() {
                return this.$store.getters.getProfitSectionSelectedManager
            },
            manager_goal: {
                get() {
                    return this.$store.getters.getProfitSectionGoalQuery.manager_goal
                },
                set(value) {
                    this.$store.dispatch('setProfitSectionGoalQueryFieldValue', { field: 'manager_goal', value: value })
                }
            }
        },
        methods: {
            updateUserSettings() {
                this.isLoading = true;
                apiUsers
                    .userSettingsUpdateRequest(this.$store.getters.getProfitSectionGoalQuery)
                    .then((response) => {
                        this.isLoading = false
                    })
                    .catch(error => console.log(error))
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/ControlPanel/Profit/ProfitManagerGoal.vue